export default function StaffDeployment() {
  const staffServices = [
    { icon: 'ri-user-star-line', title: 'General Workers & Helpers', desc: 'Skilled workers deployed at your location for various tasks' },
    { icon: 'ri-briefcase-line', title: 'Office Boy Service', desc: 'Professional office support staff for your workplace' },
    { icon: 'ri-user-settings-line', title: 'Dedicated Cleaners', desc: 'Experienced cleaning staff stationed at your premises' },
    { icon: 'ri-calendar-check-line', title: 'Flexible Contracts', desc: 'Daily and yearly contract options to suit your needs' }
  ];

  const cleaningServices = [
    'Public & Private Utility Cleaning Services',
    'General Cleaning of Buildings & Apartments',
    'Restroom Sanitization',
    'Floor Scrubbing & Polishing',
    'Tower Glass Cleaning',
    'Sofa & Carpet Shampooing',
    'Hi-Tech Deep Cleaning',
    'Complex Cleaning',
    'Post-Construction Cleaning'
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Staff Deployment & Cleaning Solutions
          </h2>
          <p className="text-xl text-teal-500 font-medium">
            Skilled Staff Deployed at Your Premises - Daily & Yearly Contract Basis
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white rounded-3xl p-10 shadow-xl">
            <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-team-line text-white text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Staff Deployment Services</h3>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed">
              We deploy skilled and experienced staff directly at your premises according to your specific requirements. Our professionals work as part of your team on a contract basis.
            </p>
            
            <div className="space-y-5">
              {staffServices.map((service, index) => (
                <div key={index} className={`flex items-start gap-4 ${index < staffServices.length - 1 ? 'pb-5 border-b border-gray-200' : ''}`}>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${service.icon} text-teal-500 text-2xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-base mb-1">{service.title}</h4>
                    <p className="text-gray-600 text-sm">{service.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-white rounded-3xl p-10 shadow-xl">
            <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-brush-line text-white text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Professional Cleaning Services</h3>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed">
              Comprehensive cleaning solutions for all types of facilities with modern equipment and eco-friendly products.
            </p>
            
            <div className="space-y-4">
              {cleaningServices.map((service, index) => (
                <div key={index} className={`flex items-start gap-4 ${index < cleaningServices.length - 1 ? 'pb-4 border-b border-gray-200' : ''}`}>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-base">{service}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
